import { Grid } from '@material-ui/core'
import { useSelector } from 'react-redux'
import React, { Fragment, useEffect, useState } from 'react'

import { useStyles } from './styles'
import Graphic from './Graphic'
import { UTCtoEspecificMaskDate } from '../../../utils/dates'
import { changeFormatNumbersGraphics } from '../../../utils/numbers'

const Graphics = ({ controlPanelData }) => {
  const classes = useStyles()
  const [oilData, setOilData] = useState([])
  const [gasData, setGasData] = useState([])
  const [waterData, setWaterData] = useState([])

  useEffect(() => {
    if (controlPanelData.length > 0) {
      getData()
    }
  }, [controlPanelData])

  const getData = () => {
    verifyProductsData()
    controlPanelData.forEach((item) => {
      if (item.type === 'Oil') {
        transformationOilData(item.details)
      }
      if (item.type === 'Gas') {
        transformationGasData(item.details)
      }
      if (item.type === 'Water') {
        transformationWaterData(item.details)
      }
    })
  }

  const verifyProductsData = () => {
    const oilExist = controlPanelData.some((item) => item.type === 'Oil')
    const waterExist = controlPanelData.some((item) => item.type === 'Water')
    const gasExist = controlPanelData.some((item) => item.type === 'Gas')

    if (!oilExist) {
      setOilData([])
    }
    if (!waterExist) {
      setWaterData([])
    }
    if (!gasExist) {
      setGasData([])
    }
  }

  const transformationOilData = (dataOil) => {
    const newDataOil = []

    dataOil.forEach((itemOil) => {
      const newItemOil = {
        OilText: changeFormatNumbersGraphics(itemOil.value),
        date: UTCtoEspecificMaskDate(itemOil.date, 'MM-DD'),
        Oil: itemOil.value,
      }
      newDataOil.push(newItemOil)
    })
    setOilData(newDataOil)
  }

  const transformationGasData = (dataGas) => {
    const newDataGas = []

    dataGas.forEach((itemGas) => {
      const newItemGas = {
        GasText: changeFormatNumbersGraphics(itemGas.value),
        date: UTCtoEspecificMaskDate(itemGas.date, 'MM-DD'),
        Gas: itemGas.value,
      }

      newDataGas.push(newItemGas)
    })
    setGasData(newDataGas)
  }

  const transformationWaterData = (dataWater) => {
    const newDataWater = []

    dataWater.forEach((itemWater) => {
      const newItemWater = {
        WaterText: changeFormatNumbersGraphics(itemWater.value),
        date: UTCtoEspecificMaskDate(itemWater.date, 'MM-DD'),
        Water: itemWater.value,
      }
      newDataWater.push(newItemWater)
    })
    setWaterData(newDataWater)
  }

  return (
    <Fragment>
      {oilData.length > 0 && (
        <Grid item xs={12}>
          <div className={classes.graphic}>
            <center>
              <Graphic
                data={oilData}
                dataKeyXAxis="date"
                dataKeyBar="Oil"
                colorFill="#bb68b3"
                dataKeyLabel="OilText"
              />
            </center>
          </div>
        </Grid>
      )}
      {waterData.length > 0 && (
        <Grid item xs={12}>
          <div className={classes.graphic}>
            <center>
              <Graphic
                data={waterData}
                dataKeyXAxis="date"
                dataKeyBar="Water"
                colorFill="#50c7c0"
                dataKeyLabel="WaterText"
              />
            </center>
          </div>
        </Grid>
      )}
      {gasData.length > 0 && (
        <Grid item xs={12}>
          <div className={classes.graphic}>
            <center>
              <Graphic
                data={gasData}
                dataKeyXAxis="date"
                dataKeyBar="Gas"
                colorFill="#ffc107"
                dataKeyLabel="GasText"
              />
            </center>
          </div>
        </Grid>
      )}
    </Fragment>
  )
}

export default Graphics
